export default __webpack_public_path__ + "static/media/BFSExp.49ba85dc.md";